import { invalidate, useQuery, useQueryClient } from "@msuite/ui/query";
import { responseHandler } from "@msuite/ui/utils";
import { guardArray } from "@msuite/utils/array";
import { RemoteFileInspector } from "@/components/files";
import { client } from "@/hono";

/** Props Interface */
interface TicketFilesProps {
	ticketId: string;
	projectId: string;
}

export function TicketFiles({ ticketId, projectId }: TicketFilesProps) {
	/** Hooks */
	const qc = useQueryClient();

	/** Query */
	const { data: ticketFiles } = useQuery({
		queryKey: ["tickets", ticketId, "files"],
		queryFn: async () => {
			const response = await client.tickets[":ticketId"].files.$get({
				param: { ticketId },
			});
			const data = await responseHandler(response);
			return data.files;
		},
	});

	/** Functions */
	async function handleOnFilesChanged() {
		await qc.invalidateQueries({ predicate: invalidate(["tickets", ticketId, "files"]) });
	}

	return (
		<RemoteFileInspector
			variant="inline"
			itemFiles={guardArray(ticketFiles).map((file) => ({ ...file, file }))}
			tableName="ticketFiles"
			foreignKey="ticketId"
			identifier={ticketId}
			additionalForeignKeyValues={{ projectId }}
			projectId={projectId}
			parent={{ ticket: { id: ticketId, projectId } }}
			withUpload
			onUnlinked={handleOnFilesChanged}
			onLinked={handleOnFilesChanged}
		/>
	);
}
